var weather = {
	wrapper: $('.nav-weather'),
	thumb: $('.weather-thumb'),
	main: $('.weather-main'),
	extended: $('.weather-extended'),

	triggerLarge: function() {
		weather.thumb.click(function(){
			if (windowWidth >= desktop) {
				weather.wrapper.toggleClass('weather-open');
				weather.main.clearQueue().stop().slideToggle();
			}
		});
	},

	triggerSmall: function() {
		weather.main.click(function(){
			if (isTouch || (!isTouch && windowWidth < desktop)) {
				weather.wrapper.toggleClass('weather-open');
				weather.extended.clearQueue().stop().slideToggle();
				$('.sidenav-navItem.active .sidenav-item-content').slideUp();
				sidenav.wrapperEl.removeClass('active');
			}
		});
	},

	clearOnResize: function() {
		weather.wrapper.removeClass('weather-open');
		weather.main.removeAttr('style');
		weather.extended.removeAttr('style');
	},

	closeMouseOut: function() {
		weather.main.mouseleave(function(){
			if (!isTouch && windowWidth >= desktop) {
				weather.wrapper.removeClass('weather-open');
				weather.main.slideUp();
			}
		});
	},

	closeClickOut: function() {
		$(document).click(function(event) {
			if (!isTouch && windowWidth >= desktop) {
				if(!$(event.target).closest(weather.wrapper).length) {
					weather.wrapper.removeClass('weather-open');
    				weather.main.slideUp();
			    }
			}
		});
	},

	init: function() {
		weather.triggerLarge();
		weather.triggerSmall();
		weather.closeMouseOut();
		weather.closeClickOut();
	}
};